/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Facet_FreezerInputs */

const en_facet_freezer = /** @type {(inputs: Facet_FreezerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freezer friendly`)
};

const de_facet_freezer = /** @type {(inputs: Facet_FreezerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Einfrieren geeignet`)
};

/**
* | output |
* | --- |
* | "Freezer friendly" |
*
* @param {Facet_FreezerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const facet_freezer = /** @type {((inputs?: Facet_FreezerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Facet_FreezerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_facet_freezer(inputs)
	return en_facet_freezer(inputs)
});